import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import { GridViewOptions } from '@/pages/CompanyReport/constants/constants';
import type { BestValuationRatio } from '@/utilities/getBestValuationRatio';

export const getIdeanameBySection = (section: CompanyReportSection) => {
  const SECTIONS_IDEANAME_MAP = {
    valuation: 'potentially-undervalued-companies',
    future: 'high-growth-potential-companies',
    past: 'sustainable-track-record',
    health: 'healthy-companies',
    dividend: 'top-dividend-stocks',
  };

  return SECTIONS_IDEANAME_MAP[section];
};

export interface Company {
  canonicalUrl: string;
  companyId: string;
  website: string;
  shortDescription: string;
  shortName: string;
  snowflakePoints: [number, number, number, number, number];
  tickerSymbol: string;
  uniqueSymbol: string;
  return1YrAbs: number | null;
  return1YrAbsFormatted: string;
  return7D: number | null;
  return7DFormatted: string;
  marketCapFormatted: string;
  peFormatted: string;
  pbFormatted: string;
  psFormatted: string;
  sharePriceFormatted: string;
  bestValuationRatio: BestValuationRatio;
  analystCount: number | null;
  earningsGrowth: number | null;
  earningsGrowthFormatted: string;
  salesGrowth: number | null;
  salesGrowthFormatted: string;
  growthEstimateFormatted: string;
  analystsPriceTargetFormatted: string;
  industryLabel: string;
  isRecentSearchEntry: boolean | null;
  hasLogo: boolean;
}

export interface Props {
  company: Company;
  section: string;
  index: number;
  hideIndustryCol?: boolean;
}

export const getTopCompanies = (
  companies: Company[],
  quantity: number,
  currentCompanyId: string
) => {
  return companies
    .filter(
      (company) =>
        company.companyId.toLowerCase() !== currentCompanyId.toLowerCase()
    )
    .slice(0, quantity);
};

export type SectionGridViewMap = {
  [K in CompanyReportSection]?: GridViewOptions;
};

export const getGridViewOptionIdBySection = (section: CompanyReportSection) => {
  const SECTIONS_GRID_VIEW_ID_MAP: SectionGridViewMap = {
    valuation: GridViewOptions.GRID_VIEW_POTENTIALLY_UNDERVALUED,
    future: GridViewOptions.GRID_VIEW_HIGH_GROWTH,
    past: GridViewOptions.GRID_VIEW_STRONG_PAST_PERFORMING,
    health: GridViewOptions.GRID_VIEW_HEALTHY,
    dividend: GridViewOptions.GRID_VIEW_DIVIDEND_NEW,
  };

  return SECTIONS_GRID_VIEW_ID_MAP[section];
};
